import { render, staticRenderFns } from "./ConfirmWithCommentModal.vue?vue&type=template&id=8f6b77b0&scoped=true"
import script from "./ConfirmWithCommentModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmWithCommentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6b77b0",
  null
  
)

export default component.exports